import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

const BlogPage = () => {
  const blogPosts = [
    {
      id: 1,
      title: '10 Essential Developer Tools Every Programmer Should Know',
      excerpt: 'Discover the must-have tools that will boost your productivity and streamline your development workflow.',
      category: 'Tools',
      date: '2025-01-15',
      readTime: '5 min read',
      slug: 'essential-developer-tools'
    },
    {
      id: 2,
      title: 'Understanding JSON: A Complete Guide',
      excerpt: 'Learn everything about JSON format, including syntax, parsing, and best practices for working with JSON data.',
      category: 'Tutorial',
      date: '2025-01-10',
      readTime: '8 min read',
      slug: 'understanding-json-guide'
    },
    {
      id: 3,
      title: 'Why Base64 Encoding Matters in Web Development',
      excerpt: 'Explore the importance of Base64 encoding and its practical applications in modern web development.',
      category: 'Guide',
      date: '2025-01-05',
      readTime: '6 min read',
      slug: 'base64-encoding-guide'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Blog</h1>
          <p className="text-gray-600 dark:text-gray-300 text-lg max-w-2xl mx-auto">
            Articles, tutorials, and guides about developer tools and web development
          </p>
        </div>

        {/* Blog Posts */}
        <div className="max-w-4xl mx-auto space-y-6">
          {blogPosts.map(post => (
            <Card key={post.id} className="hover:shadow-xl transition-shadow border-gray-200 dark:border-gray-800">
              <CardHeader>
                <div className="flex items-center gap-2 mb-2">
                  <Badge variant="secondary">{post.category}</Badge>
                  <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    {post.readTime}
                  </span>
                </div>
                <CardTitle className="text-2xl">{post.title}</CardTitle>
                <CardDescription className="text-base">{post.excerpt}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button asChild variant="ghost">
                  <Link to={`/blog/${post.slug}`}>
                    Read More
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Ad Placement */}
        <div className="mt-12 max-w-4xl mx-auto">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 text-center border-2 border-dashed border-gray-300 dark:border-gray-700">
            <p className="text-gray-500 dark:text-gray-400 text-sm">Advertisement Space</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;